export default "__VITE_ASSET__bccf6f74__"